$(document).ready(function () {
    let rectPatternID;
    $(".BODU .icon-svg-attrs").each(function() {
        rectPatternID = $(this).find("svg").find("pattern").attr('id') + "trubrain";
        $(this).find("svg").find("pattern").attr('id', rectPatternID);
        $(this).find("svg").find("rect").attr('fill', 'url(#' + rectPatternID + ')');
    });

    let prodImage = $(".popup-box .check-product").attr("product-image");
    $(".popup-box .product-image").attr('src', prodImage)
    $(".popup-box input[name='selected_prodcut']").change(function() {
        if ($(this).is(":checked")) {
            $(".check-product").removeClass("selected-product");
            $(".check-product").removeClass("border-2");
            $(this).parents(".check-product").addClass("selected-product");
            $(this).parents(".check-product").addClass("border-2");
            prodImage = $(this).parents(".check-product").attr("product-image");
            $(".popup-box .product-image").attr('src', prodImage)
        }
    });

      // add to cart
      $(".add-products-to-checkout").click(function(e){
        e.preventDefault();
        let variantID;
        let sellingPlan;
        $(this).parents(".add-products-to-checkout-head").siblings(".check-product").find("input[name='selected_prodcut']").each(function(){
          if($(this).is(":checked")){
            variantID = $(this).attr('product-variant-id');
            sellingPlan = $(this).attr('product-selling-plan');
          }
        });
        
        console.log(sellingPlan);
        console.log(variantID);
    
        //assign sku based on variantID
        let sku;
        
        if (variantID =="39296756351061"){
          sku = "TD10-1S1F1Mt1Mu2NC2NB2X";
        }
        else{
          sku ="TD30-5S5F5Mu5NC5NB5X";
        }
    
        console.log(sku);          
        
        //assign add to cart method based on variantID
        if (variantID =="32943466283093"){
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              quantity: 1,
              id: variantID,
              properties: {
                Sleep: "5",
                Mellow: "5",
                Mushrooms: "5",
                Medium: "5",
                Strong: "5",
                Extra: "5",
                sku: sku
              }
            },
            dataType: "json",
            success: function (data) {
              console.log(data.id);
              
            },
          });
        }
        else {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              quantity: 1,
              id: variantID,
              selling_plan: sellingPlan
            },
            dataType: "json",
            success: function (data) {
              console.log(data.id);
              
            },
          });
        }
        
      });

      // text animation
      function reveal() {
        var reveals = document.querySelectorAll(".BAIS .reveal");

        for (var i = 0; i < reveals.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = 10;

            if (elementTop < windowHeight - elementVisible) {
                reveals[i].classList.add("active");
            } else {
                reveals[i].classList.remove("active");
            }
        }
    }

    window.addEventListener("scroll", reveal);

    // horizonatl scroll
    $('.BARS #scrollable-row').animate({
        scrollLeft: "+=338px"
    }, "slow");

    $('.BARS .arrows .left-arrow').click(function(event) {
        event.preventDefault();
        $('.BARS #scrollable-row').animate({
            scrollLeft: "-=450px"
        }, "slow");
    });

    $('.BARS .arrows .right-arrow').click(function(event) {
        event.preventDefault();
        $('.BARS #scrollable-row').animate({
            scrollLeft: "+=450px"
        }, "slow");
    });
});